import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const StyledSelector = styled.div`
  position: relative;
`;

export const StyledSelectorInput = styled.div`
  .react-input-group {
    background: white;
  }
`;
